const imgLocalPath = 'http://192.168.31.115:8080/';
const imgServerPath = 'https://www.linhai.online/img/';
const isDevelopment = process.env.NODE_ENV === 'development';
export const reqURL = {
    
    imgBasePath: imgLocalPath,


    queryDictByCode: '/api/base/dict/typeCode',

    getSysParam: '/api/scf/sysman/prelogin/params',
    queryUsernameIsExist: '/api/scf/sysman/prelogin/queryUsernameIsExist',
    userLogin: '/api/scf/sysman/prelogin/login',
    userLoginout: '/api/scf/sysman/prelogin/loginout',
    sysuserAdd: '/api/scf/sysman/prelogin/add',
    updatePassword: '/api/scf/sysman/user/password/update',

    queryParams: '/api/scf/sysman/params/query',
    saveParams: '/api/scf/sysman/params/save',

    getLanguageByCompany :'/api/scf/base/query/getLanguageByCompany',

    /*
    文件服务
    */
    downloadFileById: isDevelopment ? '/api/scf/base/file/download' : '/api/scf/base/file/download',
    fileUpload: isDevelopment ? '/api/api/scf/base/file/upload' : '/api/scf/base/file/upload',
    imgPreview: '/api/scf/base/public/file/img/preview',
    exportByDyAPI: '/api/scf/base/file/export',

    
    /*
    流程定义接口
    */ 
    queryFlowNodeLib: '/api/base/flow/node/lib/query',
    queryAllFlowDefinition: '/api/base/flow/definition/queryAll',
    queryFlowElements: '/api/base/flow/definition/elements',
    saveFlowDefinition: '/api/base/flow/definition/save',
    delFlowDefinition: '/api/base/flow/definition/del',



    queryRoleAuthrityByCode: '/api/scf/base/query/queryRoleAuthrityByCode',

    querySysMenu: '/api/scf/sysman/menumgr/querySysMenu',
    addSysMenu: '/api/scf/sysman/menumgr/add',
    updateSysMenu: '/api/scf/sysman/menumgr/update',
    delSysMenu: '/api/scf/sysman/menumgr/del',

    querySysRole: '/api/scf/base/query/queryRole',
    addSysRole: '/api/scf/sysman/role/add',
    updateSysRole: '/api/scf/sysman/role/update',
    delSysRole: '/api/scf/sysman/role/del',
    queryAuthMenu: '/api/scf/sysman/role/queryAuthMenu',
    saveRoleAuth: '/api/scf/sysman/role/saveRoleAuth',

    queryOrgList: '/api/scf/sysman/company/org/list',
    queryCompany: '/api/scf/sysman/company/query',
    addCompany: '/api/scf/sysman/company/add',
    updateCompany: '/api/scf/sysman/company/update',
    delCompany: '/api/scf/sysman/company/del',

    
    queryCompanyUserList: '/api/scf/sysman/company/user/list',
    getUserById: '/api/scf/base/query/getUserById',
    addCompanyUser: '/api/scf/sysman/company/user/add',
    updateCompanyUser: '/api/scf/sysman/company/user/update',
    delCompanyUser: '/api/scf/sysman/company/user/del',
    allotCompanyUserRoles: '/api/scf/sysman/company/user/allot',
    relatedCompanyUser: '/api/scf/sysman/company/user/related',


    statisticDeviceByType: '/api/scf/base/query/statisticDeviceByType',

    getTypeOptions: '/api/scf/base/query/getTypeOptions', 
    getDeviceList: '/api/scf/base/query/getDeviceList',
    getDeviceCount: '/api/scf/base/query/getDeviceCount',
    getCompanyOptions: '/api/scf/base/query/getCompanyOptions',
    addDevice: '/api/scf/limas/device/add',
    updateDevice: '/api/scf/limas/device/update',
    delDevice: '/api/scf/base/update/delDevice',
    getDeviceOptions: '/api/scf/base/query/getDeviceOptions',
    clearWarning: '/api/scf/limas/device/clear',
    importDevice: '/api/scf/limas/device/import',
    getDeviceWarningConfig: '/api/scf/base/query/getDeviceWarningConfig',
    saveDeviceWarningConfig : '/api/scf/limas/device/warning/config',

    addMaintainOrder: '/api/scf/base/add/addMaintainOrder',
    updateMaintainOrder: '/api/scf/base/update/updateMaintainOrder',
    getMaintainList: '/api/scf/base/query/getMaintainList',
    getMaintainCount: '/api/scf/base/query/getMaintainCount',


    getDeviceTypeList: '/api/scf/limas/definition/device/type/list',
    addDeviceType: '/api/scf/limas/definition/device/type/add',
    updateDeviceType: '/api/scf/limas/definition/device/type/update',
    delDeviceType: '/api/scf/limas/definition/device/type/del',
    getDataDefinition: '/api/scf/base/query/getDataDefinition',
    addDataDefinition: '/api/scf/limas/definition/data/add',
    updateDataDefinition: '/api/scf/limas/definition/data/update',
    delDataDefinition: '/api/scf/limas/definition/data/del',
    getDeviceDataList: '/api/scf/base/query/getDeviceDataList',
    getDeviceDataCount: '/api/scf/base/query/getDeviceDataCount',
    getDatasByDeviceId: '/api/scf/base/query/getDatasByDeviceId',
    getDatasCountByDeviceId: '/api/scf/base/query/getDatasCountByDeviceId',
    getWarningDataList: '/api/scf/base/query/getWarningDataList',
    getWarningDataCount: '/api/scf/base/query/getWarningDataCount',
    getLatestWarningData: '/api/scf/base/query/getLatestWarningData',

    statisticDeviceCountByStatus: '/api/scf/base/query/statisticDeviceCountByStatus',
    statisticDeviceCountByWarningStatus: '/api/scf/base/query/statisticDeviceCountByWarningStatus',
    statisticWarningCount: '/api/scf/base/query/statisticWarningCount',
    statisticWarningCountByLevel: '/api/scf/base/query/statisticWarningCountByLevel',
    statisticWarningRecoveryRate: '/api/scf/base/query/statisticWarningRecoveryRate',
    getDeviceLatestDataById: '/api/scf/base/query/getDeviceLatestDataById',
    getLatestDataByElement: '/api/scf/base/query/getLatestDataByElement',

    exportDeviceData: '/api/scf/limas/device/exportHistory',
    exportImportDatas: '/api/scf/limas/device/exportImportDatas',


}
export default reqURL